import { History, Location, UnregisterCallback } from 'history';
import { reaction } from 'mobx';
import { Models } from '../../App';

export interface SyncedHistory extends History {
  unsubscribe?: UnregisterCallback;
}

export const syncParamsWithStore = (params: any, routerStore: Models['router']) => {
  routerStore.setParams(params);
};

export const syncHistoryWithStore = (history: SyncedHistory, routerStore: Models['router']) => {
  routerStore.setHistory(history);

  function isLocationEqual(locationA: Location, locationB: Location) {
    return (
      locationA
      && locationB
      && locationA.key
      && locationB.key
      && locationA.key === locationB.key
    );
  }

  // Handle update from history object
  const handleLocationChange = (location: Location) => {
    if (!isLocationEqual(routerStore.location, location)) {
      routerStore.updateLocation({ ...location });
    }
  };
  const unsubscribeFromHistory = history.listen(handleLocationChange);
  const unsubscribeFromStoreLocation = reaction(
    () => routerStore.location,
    (location: Location) => {
      if (!isLocationEqual(history.location, location)) {
        history.replace({ ...location });
      }
    },
  );

  history.unsubscribe = () => {
    unsubscribeFromHistory();
    unsubscribeFromStoreLocation();
  };

  handleLocationChange(history.location);

  return history;
};
